import { render, staticRenderFns } from "./ImageDataUpload.vue?vue&type=template&id=180c8e71&scoped=true&"
import script from "./ImageDataUpload.vue?vue&type=script&lang=ts&"
export * from "./ImageDataUpload.vue?vue&type=script&lang=ts&"
import style0 from "./ImageDataUpload.vue?vue&type=style&index=0&id=180c8e71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180c8e71",
  null
  
)

export default component.exports